export const USER_NS = 'user';

export const USER_TOKEN = 'user_token';
export const TOKEN_TYPE = 'token_type';
export const EXPIRES_IN = 'expires_in';
export const ID_TOKEN = 'id_token';

export const USER_NAME = 'user_name';



// WEBPACK FOOTER //
// ./src/store/modules/user/constants.js